

<!-- let's make a responsive form that can serve as a template for other forms -->


<div style="width: 500px; margin: 0 auto;">

    <div class="form-group">

        <!-- two columns, one for textboxes, one for selectboxes and checkboxes -->
        <div style="display:flex; flex-direction: row; gap:50px;">
            <div style="display:flex; flex-direction: column; gap:10px;">
                <app-textbox [label]="'Currency USD'" style="width:100px;" [type]="TextModes.CurrencyUSD" [validateOn]="'change'"></app-textbox>
                <app-textbox [label]="'Percent'" style="width:100px;" [type]="TextModes.Percent"></app-textbox>
            </div>
            <div style="display:flex; flex-direction: column; gap:10px;">
                <app-selectbox [label]="'This is the label'" [options]="options"></app-selectbox>
                <app-checkbox [label]="'This is the label'"></app-checkbox>
            </div>
        </div>
    </div>
    <div class="form-group">
        <app-radiobox [label]="'This is the label'" [displayDirection]="'horizontal'"></app-radiobox>
        <app-radiobox [label]="'This is the label'" [displayDirection]="'vertical'"></app-radiobox>
    </div>
    <div class="form-group">
        <app-onoff [label]="'This is the label'"></app-onoff>
    </div>
    <div class="form-group">
        <app-rangebox [label]="'This is the label'"></app-rangebox>
    </div>
    <div class="form-group">
        <button class="primary">Submit</button>
    </div>

</div>